import { Directive, Input, SimpleChanges } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
    standalone: true,
    selector: '[jhi-forbiddenCharactersValidator][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: ForbiddenCharactersValidatorDirective,
            multi: true
        }
    ]
})
export class ForbiddenCharactersValidatorDirective implements Validator {
    private readonly DEFAULT_FORBIDDEN_CHARS = ['<', '>', '?', '%', '|'];
    @Input('forbidden_chars') forbiddenChars?: string[] | string;

    private onValidatorChange?: () => void;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.forbiddenChars && this.onValidatorChange) {
            this.onValidatorChange();
        }
    }

    validate(control: AbstractControl): ValidationErrors | null {
        const value = control.value || '';
        const forbiddenChars = this.getForbiddenChars();
        const containsForbidden = forbiddenChars.some((char) => value.includes(char));

        if (containsForbidden) {
            return { forbiddenCharacters: true };
        }

        return null;
    }

    registerOnValidatorChange?(fn: () => void): void {
        this.onValidatorChange = fn;
    }

    private getForbiddenChars(): string[] {
        if (Array.isArray(this.forbiddenChars)) {
            return this.forbiddenChars;
        }

        if (typeof this.forbiddenChars === 'string' && this.forbiddenChars.length > 0) {
            return this.forbiddenChars.split('');
        }

        return this.DEFAULT_FORBIDDEN_CHARS;
    }
}
